/* @flow */

import $ from 'jquery';
import scrollIntoView from 'scroll-into-view-if-needed';
import get from 'lodash/get';

export const removeErrorOnInput = (name: string) => {
    $(`[name="${name}"]`)
        .closest('.form-group')
        .removeClass('has-danger')
        .find('.form-control-feedback')
        .html('');
};

export const setErrorOnInput = (name: string, message: string) => {
    $(`[name="${name}"]`)
        .closest('.form-group')
        .addClass('has-danger')
        .find('.form-control-feedback')
        .html(message);
};

export const limparErrosFormulario = (form: HTMLFormElement) => {
    Array.from(form.elements).forEach((element) => {
        if (element instanceof HTMLInputElement || element instanceof HTMLSelectElement) {
            removeErrorOnInput(element.name);
        }
    });
};

export const mostrarMensagens = (messages: Object) => {
    scrollIntoView(document.body, {
        scrollMode: 'if-needed',
        behavior: 'smooth',
    });

    Object.keys(messages).forEach((name) => {
        setErrorOnInput(name, messages[name]);
    });
};

export const mostrarMensagensPorError = (error: Error) => {
    mostrarMensagens(get(error, 'response.data.messages', 'Não sabemos o que ocorreu!'));
};
